module.exports = __webpack_public_path__ + "static/media/V2_20.062fcbdb.png";